'use client';

export { LanguageChangeProvider, useLanguageChange, type StartNavigation } from '@inkitt/utils-web';
